@if (apiFragment$ | async; as record) {
  <dt class="sh-description-list__term">{{ labels.get('Regimen') }}</dt>
  <dd class="sh-description-list__details">{{ record.metadata.Dynamic.RecordReuse?.Regimen || '-' }}</dd>
  @if (record.metadata.Dynamic.RecordReuse?.Motivations?.Motivation?.length > 0) {
    <dt class="sh-description-list__term">{{ labels.get('Motivations') }}</dt>
    <dd class="sh-description-list__details">
      <ul class="edp-unstyled-list">
        @for (motivation of record.metadata.Dynamic.RecordReuse.Motivations.Motivation; track motivation) {
          <li>{{motivation}}</li>
        }
      </ul>
    </dd>
  }
  @if (record.metadata.Dynamic.RecordReuse?.License) {
    <dt class="sh-description-list__term">{{ labels.get('License') }}</dt>
    <dd class="sh-description-list__details">{{ record.metadata.Dynamic.RecordReuse?.License }}</dd>
  }
}
